const VERIFY_URL = '/admin/ga4/verify'

export const verifyStream = async ({ platform, property_id, stream_id }) => {
  try {
    const response = await fetch(VERIFY_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ platform, property_id, stream_id })
    })
    if (response.status === 429) return { status: 'rate_limited' }
    if (response.status === 403) return { status: 'forbidden' }
    return await response.json()
  } catch (error) {
    return { status: 'error' }
  }
}

const MESSAGES = {
  not_configured: 'GA4 credentials are not configured in this environment.',
  no_access: 'The service account has no access to this property.',
  unavailable: 'Google Analytics is unavailable or over quota. Try again later.',
  rate_limited: 'Too many checks. Wait a minute and try again.',
  forbidden: 'Only admins can verify streams.',
  error: 'Could not reach the server.'
}

// Plain-text lines. Callers must render them as text, never as HTML: stream names come from Google.
export const describeResult = result => {
  const lines = []
  if (result.status === 'ok') {
    lines.push(`Found "${result.stream_name}" (${result.platform}), data from ${result.first_date} to ${result.last_date}.`)
  } else if (result.status === 'no_data') {
    lines.push('No data found for this stream. Check the IDs, or it has not recorded events yet.')
  } else if (result.status === 'invalid') {
    lines.push(result.error || 'Invalid request.')
  } else {
    lines.push(MESSAGES[result.status] || 'Unexpected response.')
  }
  if (result.warning) lines.push(`Warning: ${result.warning}`)
  if (result.custom_dimensions) {
    const missing = Object.keys(result.custom_dimensions).filter(name => !result.custom_dimensions[name])
    lines.push(missing.length ? `Missing custom dimensions: ${missing.join(', ')}.` : 'All expected custom dimensions are registered.')
  }
  return lines
}
